/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Dach_Specific_NotesInputs */

const en_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const de_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const fr_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const es_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const it_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const nl_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const pl_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const fi_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const da_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

const sv_negotiation_dach_specific_notes = /** @type {(inputs: Negotiation_Dach_Specific_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DACH-specific notes`)
};

/**
* | output |
* | --- |
* | "DACH-specific notes" |
*
* @param {Negotiation_Dach_Specific_NotesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_dach_specific_notes = /** @type {((inputs?: Negotiation_Dach_Specific_NotesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Dach_Specific_NotesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_dach_specific_notes(inputs)
	if (locale === "fr") return fr_negotiation_dach_specific_notes(inputs)
	if (locale === "es") return es_negotiation_dach_specific_notes(inputs)
	if (locale === "it") return it_negotiation_dach_specific_notes(inputs)
	if (locale === "nl") return nl_negotiation_dach_specific_notes(inputs)
	if (locale === "pl") return pl_negotiation_dach_specific_notes(inputs)
	if (locale === "fi") return fi_negotiation_dach_specific_notes(inputs)
	if (locale === "da") return da_negotiation_dach_specific_notes(inputs)
	if (locale === "sv") return sv_negotiation_dach_specific_notes(inputs)
	return en_negotiation_dach_specific_notes(inputs)
});